import React, { useEffect, useState } from "react";
import axios from "axios";
import { API_BASE_URL } from "../config/apiBase";
import Sidebar from "../components/Sidebar";
import Navbar from "../components/Navbar";
import { FaCalendarAlt } from "react-icons/fa";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "./Transactions.css";

const AdminRevenueReport = () => {
    const [reportData, setReportData] = useState([]);
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const [loading, setLoading] = useState(true);
    const [isSidebarOpen, setIsSidebarOpen] = useState(true);

    const adminUser = JSON.parse(localStorage.getItem("user"));


useEffect(() => {
    if (!adminUser?.isAdmin) return;

    const fetchReport = async () => {
        let result = []; // <-- move declaration here
        try {
            const token = localStorage.getItem("token");
            const [txRes, courseRes] = await Promise.all([
                axios.get(`${API_BASE_URL}/transactions/allTransactions`, {
                    headers: { Authorization: `Bearer ${token}` },
                }),
                axios.get(`${API_BASE_URL}/courses/allCourses`, {
                    headers: { Authorization: `Bearer ${token}` },
                }),
            ]);

            console.log("Transactions:", txRes.data);
            console.log("Courses:", courseRes.data);

            let transactions = txRes.data;
            const courses = courseRes.data;

            // apply filter
            if (startDate && endDate) {
                transactions = transactions.filter((tx) => {
                    const date = tx.date ? new Date(tx.date) : null;
                    if (!date || isNaN(date)) return false;
                    return date >= startDate && date <= endDate;
                });
            }

            const courseMap = {};
            for (const course of courses) {
                courseMap[course.wooProductId] = {
                    title: course.title,
                    price: course.price || 0,
                    enrolled: 0,
                    revenue: 0,
                };
            }

            for (const tx of transactions) {
                const course = courseMap[tx.Product];
                if (course && tx.status === "Completed") {
                    course.enrolled += 1;
                    course.revenue += Number(tx.amount || 0);
                }
            }

            result = Object.values(courseMap).filter((c) => c.enrolled > 0);
            setReportData(result);
        } catch (err) {
            console.error("❌ Failed to load revenue report", err);
        } finally {
            console.log("✅ Finished processing data", result); // No longer throws error
            setLoading(false);
        }
    };

    fetchReport();
}, [startDate, endDate]);

    const totalEnrolled = reportData.reduce((acc, c) => acc + c.enrolled, 0);
    const totalRevenue = reportData.reduce((acc, c) => acc + c.revenue, 0);
    const avgPurchaseValue = totalEnrolled ? (totalRevenue / totalEnrolled).toFixed(2) : 0;

    return (
        <div className="dashboard-wrapper">
            <div className="sidebar-fixed">
                <Sidebar isOpen={isSidebarOpen} />
            </div>

            <div className="dashboard-main">
                <Navbar onToggleSidebar={() => setIsSidebarOpen((prev) => !prev)} />

                <div className="transaction-content">
                    <div className="table-container">
                        <div className="table-header">
                            <h4 className="section-title">📊 Revenue & Enrollment Report</h4>
                            <div className="date-range">
                                <FaCalendarAlt />
                                <DatePicker
                                    selected={startDate}
                                    onChange={([start, end]) => {
                                        setStartDate(start);
                                        setEndDate(end);
                                    }}
                                    startDate={startDate}
                                    endDate={endDate}
                                    selectsRange
                                    isClearable
                                    placeholderText="Filter by date range"
                                    className="date-picker-input"
                                />
                            </div>
                        </div>

                        {loading ? (
                            <p>Loading report...</p>
                        ) : (
                            <>
                                <div className="table-scroll-wrapper">
                                    <table className="transactions-table">
                                        <thead>
                                            <tr>
                                                <th>Course</th>
                                                <th>Price</th>
                                                <th>Enrolled</th>
                                                <th>Total Revenue</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {reportData.map((course, index) => (
                                                <tr key={index}>
                                                    <td>{course.title}</td>
                                                    <td>${course.price}</td>
                                                    <td>{course.enrolled}</td>
                                                    <td>${course.revenue.toLocaleString()}</td>
                                                </tr>
                                            ))}
                                            <tr className="summary-row">
                                                <td><strong>TOTAL</strong></td>
                                                <td>—</td>
                                                <td><strong>{totalEnrolled}</strong></td>
                                                <td><strong>${totalRevenue.toLocaleString()}</strong></td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>

                                <div className="avg-purchase-value">
                                    📈 Avg. Purchase Value: <strong>${avgPurchaseValue}</strong> per student
                                </div>
                            </>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AdminRevenueReport;
